type QueryValue = string | number | boolean | null | undefined;
type QueryParams = Record<string, QueryValue>;

/**
 * Builds a query string, skipping params whose value is null, undefined, or ''.
 * `0` and `false` are preserved (valid values).
 */
export const buildQueryString = (params: QueryParams): string => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') return;
    searchParams.append(key, String(value));
  });
  const query = searchParams.toString();
  return query ? `?${query}` : '';
};
